/**
 * Landing — public landing page placeholder.
 *
 * Pre-launch: just the existing "Booking opens..." copy that lived in App.js
 * before routing was added. Post-launch: full hero + 3-step CTA + trip
 * cards (separate PR).
 */

import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function Landing() {
  return (
    <>
      <Helmet>
        <title>Nowhere Charters — Go Nowhere.</title>
        <meta
          name="description"
          content="Leisure boat charters from Fernandina Beach, FL. Sunset cruises, Cumberland Island, sandbar runs, and private charters."
        />
      </Helmet>

      <main
        style={{
          padding: '4rem 1.5rem',
          maxWidth: '720px',
          margin: '0 auto',
          textAlign: 'center',
        }}
      >
        <h1 style={{ marginTop: 0, fontSize: '2rem' }}>Nowhere Charters</h1>
        <p style={{ fontSize: '1.125rem', lineHeight: 1.6 }}>
          Leisure boat charters from Fernandina Beach, FL. Booking opens
          October 2026.
        </p>
        <p style={{ marginTop: '2rem', opacity: 0.7 }}>
          The booking app for this site is still under construction.
        </p>
      </main>
    </>
  );
}
